import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatOption } from '@angular/material/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { FuseConfirmationConfig, FuseConfirmationService } from '@fuse/services/confirmation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Subject, takeUntil } from 'rxjs';
import { SwiperOptions } from 'swiper';
import { ProfilesService } from '../profiles.service';
import { Portfolio, Profile } from '../profiles.type';

import SwiperCore, { Pagination } from "swiper";
SwiperCore.use([Pagination]);

@Component({
  selector: 'app-list-portfolios',
  templateUrl: './list-portfolios.component.html',
  styles         : [
    `
    @import "~swiper/css";
@import "~swiper/css/effect-cube";
@import "~swiper/css/pagination";


:root {
  --swiper-theme-color:#16A34A;
}

        fuse-card {
            margin: 16px;
        }
    `
],
encapsulation  : ViewEncapsulation.None,
changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListPortfoliosComponent implements OnInit, OnDestroy {
  @ViewChildren(FuseCardComponent, {read: ElementRef}) private _fuseCards: QueryList<ElementRef>;
  @ViewChild('allSelected') private allSelected: MatOption;
  selectedFilter: string = 'all';
  public skills;
  profile: Profile;
  portfolios: Portfolio[];
  
  filters: string[] = ['all'];
  numberOfCards: any = {};
  // public selectedSkills = [3,2];
  
  selectSkills = new FormControl();
  searchForm: FormGroup;
  // searchFormDefaults: any = {
  //     // keywords  : '',
  //     // type      : 'any',
  //     // selectSkills: new FormControl(this.selectedSkills),
  //     // isTrashed : false,
  //     // isArchived: false,
  //     // isStarred : false
  // };

  constructor(
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private _profilesService: ProfilesService,
    private _changeDetectorRef: ChangeDetectorRef,
    // private _elementRef: ElementRef,
    private _fuseConfirmationService: FuseConfirmationService,
    private _activatedRoute: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _router: Router,
    // private _route: ActivatedRouteSnapshot

  ) { }

  columns: number = 4;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  ngOnInit(): void {
    // console.log(this._activatedRoute.snapshot.params.skills.length);
    // console.log('this._activatedRoute.snapshot.params.skills.length');

    if (this._activatedRoute.snapshot.params.skills !== undefined) {
      if (this._activatedRoute.snapshot.params.skills.length > 0) {
        this.selectSkills = new FormControl(this._activatedRoute.snapshot.params.skills.split(',').map(Number));
      } 
    }

// else {
  // this.selectSkills = new FormControl(this._activatedRoute.snapshot.params.skills.split(',').map(Number));

// }
    // this._activatedRoute.params.subscribe((params: any) => {
    // this.selectedSkills = this._activatedRoute.snapshot.params.skills.split(',').map(Number);
  // console.log(" <<<<");

  //   console.log(  this._activatedRoute.snapshot.params.skills.split(','));
    // console.log(this.selectedSkills);
  //   console.log(" <<<<");

    // });
    
    console.log("profile <<<< before");
    this._profilesService.courses$
.pipe(takeUntil(this._unsubscribeAll))
.subscribe((res: any) => {

  console.log("res <<<<");
  console.log(res);
    // Get the course
    this.portfolios = res.hirePortfolios;
    this.portfolios.sort(() => Math.random() - 0.5);
    console.log("portfolios <<<<");
    console.log(this.portfolios);

    this.skills = res.hireSkills;
    // this.skills.push({id: 0, name: "All"});
    // this.skills.sort(function(a, b) {
    //   return +a.id - +b.id;
    // });

    this.skills.sort((a, b) => a.name.localeCompare(b.name));
    


    // Go to step
  //   this.goToStep(profile.progress.currentStep);

    // Mark for check
    this._changeDetectorRef.markForCheck();
});

// Subscribe to media changes
this._fuseMediaWatcherService.onMediaChange$
.pipe(takeUntil(this._unsubscribeAll))
.subscribe(({matchingAliases}) => {

    // Set the masonry columns
    //
    // This if block structured in a way so that only the
    // biggest matching alias will be used to set the column
    // count.
    if ( matchingAliases.includes('xl') )
    {
        this.columns = 5;
    }
    else if ( matchingAliases.includes('lg') )
    {
        this.columns = 4;
    }
    else if ( matchingAliases.includes('md') )
    {
        this.columns = 3;
    }
    else if ( matchingAliases.includes('sm') )
    {
        this.columns = 2;
    }
    else
    {
        this.columns = 1;
    }
});



  }


  /**
   * On destroy
   */
   ngOnDestroy(): void
   {
       // Unsubscribe from all subscriptions
       this._unsubscribeAll.next(null);
       this._unsubscribeAll.complete();
   }
 
   
 
 viewPortfolioImgs(hirePortfolio, i) {
     const data: FuseConfirmationConfig = {
         "title": hirePortfolio.title,
         "message": "<img class='rounded object-cover' src=\"https://storage.googleapis.com/eseel_publicend_inventory/" + this.profile.store.online_id + "/portfolios/" + hirePortfolio.id + "/" + hirePortfolio.hirePortfolioImgs[i].id + "/" + hirePortfolio.hirePortfolioImgs[i].name + "_3x." + hirePortfolio.hirePortfolioImgs[i].ext + "\" alt=\"Card cover image\" >" ,
         "icon": {
           "show": false,
           "name": "heroicons_outline:exclamation",
           "color": "warn"
         },
         "actions": {
           "confirm": {
             "show": false,
             "label": "Remove",
             "color": "warn"
           },
           "cancel": {
             "show": true,
             "label": "Close"
           }
         },
         "dismissible": true
       }
 this._fuseConfirmationService.open(data);
 
 
 }
 
 addAllFilters() {
  var classes = "filter-0 ";
 this.skills.forEach(elm => {
   classes += "filter-" + elm.id + " ";
 });
 return classes;
 }
 
 addFilters(hirePortfolio) {
   var classes = "filter-0 ";
   hirePortfolio.hireSkills.forEach(elm => {
    classes += "filter-" + elm.id + " ";
  });
  return classes;
  }
 
     /**
      * On filter change
      *
      * @param change
      */
      onFilterChange(change: MatButtonToggleChange): void
      {
          // Set the filter
          this.selectedFilter = change.value;
  
          // Filter the cards
          this._filterCards();
      }
 
      private _filterCards(): void
      {
          // Go through all fuse-cards
          this._fuseCards.forEach((fuseCard) => {
  
              // If the 'all' filter is selected...
              if ( this.selectedFilter === 'all' )
              {
                  // Remove hidden class from all cards
                  fuseCard.nativeElement.classList.remove('hidden');
              }
              // Otherwise...
              else
              {
                  // If the card has the class name that matches the selected filter...
                  if ( fuseCard.nativeElement.classList.contains('filter-' + this.selectedFilter) )
                  {
                      // Remove the hidden class
                      fuseCard.nativeElement.classList.remove('hidden');
                  }
                  // Otherwise
                  else
                  {
                      // Add the hidden class
                      fuseCard.nativeElement.classList.add('hidden');
                  }
              }
          });
      }

          /**
     * Reset the search form using the default
     */
    // reset(): void
    // {
    //     this.searchForm.reset(this.searchFormDefaults);
    // }


          /**
     * Perform the search
     */
    search(): void
    {
        // Add query params using the router
        this._router.navigate(['./'], {
            queryParams: this.searchForm.value,
            relativeTo : this._activatedRoute
        });
    }
          /**
     * Perform the search
     */
    searchSkills(event): void
    {
        // Add query params using the router
        // this._router.navigate(['./'], {
        //     queryParams: this.searchForm.value,
        //     relativeTo : this._activatedRoute
        // });
        console.log("skills are ");
        console.log(event);
        // console.log(this.selectedSkills);
    if (!event) {
      this._router.navigate(['/p',{skills: this.selectSkills.value } ]); 
    }
        
    }

    toggleAllSelection() {
      if (this.allSelected.selected) {
        this.selectSkills.patchValue([...this.skills.map(item => item.id), 0]);
      } else {
        this.selectSkills.patchValue([]);
      }
    }

    config: SwiperOptions = {
      slidesPerView: 3,
      spaceBetween: 50,
      navigation: true,
      pagination: { clickable: true },
      scrollbar: { draggable: true },
    };
    onSwiper([swiper]) {
      console.log(swiper);
    }
    onSlideChange() {
      console.log('slide change');
    }

}




